/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_CalculatingInputs */

const en_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating...`)
};

const de_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne...`)
};

const fr_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul en cours...`)
};

const es_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando...`)
};

const it_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolo in corso...`)
};

const nl_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berekenen...`)
};

const pl_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obliczanie...`)
};

const fi_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasketaan...`)
};

const da_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beregner...`)
};

const sv_ats_score_calculating = /** @type {(inputs: Ats_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beräknar...`)
};

/**
* | output |
* | --- |
* | "Calculating..." |
*
* @param {Ats_Score_CalculatingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_calculating = /** @type {((inputs?: Ats_Score_CalculatingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_CalculatingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_calculating(inputs)
	if (locale === "fr") return fr_ats_score_calculating(inputs)
	if (locale === "es") return es_ats_score_calculating(inputs)
	if (locale === "it") return it_ats_score_calculating(inputs)
	if (locale === "nl") return nl_ats_score_calculating(inputs)
	if (locale === "pl") return pl_ats_score_calculating(inputs)
	if (locale === "fi") return fi_ats_score_calculating(inputs)
	if (locale === "da") return da_ats_score_calculating(inputs)
	if (locale === "sv") return sv_ats_score_calculating(inputs)
	return en_ats_score_calculating(inputs)
});